import $ from 'jquery';

export default class Tab {

    init() {
        // Add class name "active" to parent element 
        $('a[data-toggle="tab"]').on('shown.bs.tab', function(e) {
            $(e.target).parent().addClass('active');
            $(e.relatedTarget).parent().removeClass('active');
        });
    }

}